import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { isAbstractMenuManager } from '@jbrowse/core/util';
import Plugin from '@jbrowse/core/Plugin';
import CircularViewF from './CircularView';
import LaunchCircularViewF from './LaunchCircularView';
// icons
import DataUsageIcon from '@mui/icons-material/DataUsage';
var CircularViewPlugin = /*#__PURE__*/function (_Plugin) {
  _inherits(CircularViewPlugin, _Plugin);
  function CircularViewPlugin() {
    var _this;
    _classCallCheck(this, CircularViewPlugin);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CircularViewPlugin).apply(this, arguments));
    _this.name = 'CircularViewPlugin';
    return _this;
  }
  _createClass(CircularViewPlugin, [{
    key: "install",
    value: function install(pluginManager) {
      CircularViewF(pluginManager);
      LaunchCircularViewF(pluginManager);
    }
  }, {
    key: "configure",
    value: function configure(pluginManager) {
      if (isAbstractMenuManager(pluginManager.rootModel)) {
        pluginManager.rootModel.appendToSubMenu(['Add'], {
          label: 'Circular view',
          icon: DataUsageIcon,
          onClick: function onClick(session) {
            session.addView('CircularView', {});
          }
        });
      }
    }
  }]);
  return CircularViewPlugin;
}(Plugin);
export { CircularViewPlugin as default };
export { baseChordDisplayConfig, BaseChordDisplayModel, BaseChordDisplayComponent } from './BaseChordDisplay';